import React from 'react';
import { useNavigate, useParams } from 'react-router';

import styled from '@emotion/styled';

import Stars from '../../../components/Badge/Stars';
import StatusCell from '../../../components/Badge/StatusCell';
import Tooltip from '../../../components/Tooltip/Tooltip';
import {
  DRIVER_INFORMATION,
  DRIVER_OVERALL_PERFORMANCE,
} from '../../../routes/routeConstants';

const DriverBioArea = () => {
  const navigate = useNavigate();
  const { companyId, companyName, driverId, jsonData } = useParams();

  const objectFyData = jsonData
    ? JSON.parse(decodeURIComponent(jsonData ?? ''))
    : null;

  return (
    <ContainerWrapper>
      <Container>
        <Img
          src={
            !!objectFyData?.profilePicture
              ? objectFyData.profilePicture
              : '/static/img/profilePlaceholder2.png'
          }
        />
        <TextArea>
          <FirstTextRow>
            <BoldText>
              {objectFyData?.firstName} {objectFyData?.lastName}
            </BoldText>
          </FirstTextRow>

          <TextRow>Driver</TextRow>

          <TextRow>
            <div>Average Timeline:</div>
            <BoldNumberText>
              {objectFyData?.timeAtCompany || 'N/A'}
            </BoldNumberText>
          </TextRow>

          <TextRow>
            <StarArea>
              <Stars numStars={Number(objectFyData?.averageRating)} />{' '}
              <Tooltip content='This shows the average cumulative star rating of a driver across all trips completed for all companies' />
              <BoldNumberText className='margin-left'>
                {Number(objectFyData?.averageRating ?? 0)} (
                {objectFyData?.totalNumberOfRatings || 0})
              </BoldNumberText>
            </StarArea>
            <div>Current company:</div>
            <BoldNumberText>
              {objectFyData?.currentCompanyName || 'N/A'}
            </BoldNumberText>

            {objectFyData?.currentCompanyName ? (
              <StatusCell
                data={{ status: objectFyData?.employmentType || 'N/A' }}
                statusKey='status'
                customClasses='small-border-radius'
              />
            ) : (
              <StatusCell
                data={{ status: 'unemployed' }}
                statusKey='status'
                customClasses='small-border-radius'
              />
            )}
          </TextRow>
        </TextArea>
      </Container>{' '}
      <NavBtn
        onClick={() => {
          navigate(
            `/${DRIVER_INFORMATION}/${companyId}/${companyName}/${driverId}/performance/${jsonData}/${DRIVER_OVERALL_PERFORMANCE}`,
          );
        }}
      >
        View Overall Driver Performance
      </NavBtn>
    </ContainerWrapper>
  );
};

export default DriverBioArea;

const StarArea = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

const ContainerWrapper = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: 1fr auto;
  gap: 70px;
  width: 100%;
`;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 32px;
  display: flex;
  gap: 16px;
  border-radius: 5px;

  gap: 24px;

  @media (max-width: 884px) {
    flex-direction: column;
    gap: 16px;
    padding: 20px;
  }
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Img = styled.img`
  width: 91px;
  height: 91px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid transparent;

  @media (max-width: 884px) {
    min-width: 91px;
    min-height: 91px;
  }
`;

const BoldText = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const FirstTextRow = styled.div`
  display: flex;
  gap: 12px;
`;

const TextRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${({ theme }) => theme.palette.grayTextColor};

  &.broken {
    @media (max-width: 884px) {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
    }
  }
`;

const BoldNumberText = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;

  &.margin-left {
    margin-left: 10px;
  }
`;

const NavBtn = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.blueColor};
  border: 1px solid ${({ theme }) => theme.palette.blueColor};
  width: fit-content;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  height: fit-content;
  font-weight: 600;
`;
